import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { PscInspectionModel, SavePscResponse } from "../models/psc.models";
import { UnitOfWorkItem } from "@rightship-tech/common-ui/helpers/unit-of-work-observer";
import { DeficiencyDetails } from "../models/psc.models";
import { AttachmentFile } from "@rightship-tech/common-ui/models/attachments.models";

@autoinject
export class PscService {

    public pscApi: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/Psc`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    //Get PSC by Id
    public getPsc(id: number): Promise<PscInspectionModel> {
        return this.requestClientService.get(`${this.pscApi}/GetPsc/${id}`, {});
    }

    //Save PSC
    public savePsc(id: number, syncToMdm:boolean, changes: { [index: string]: UnitOfWorkItem }, cfrId:number, files: AttachmentFile[], 
        isCloseOut: boolean = false): Promise<SavePscResponse> {

        let attachmentFiles= files.map(c=>{
            return {attachementTypeId:c.attachmentTypeId, file: c as File}
        });

        return this.requestClientService.postFormData(`${this.pscApi}/SavePsc`, { id: id, cfrId: cfrId, syncToMdm:syncToMdm, changes: changes, 
            files: attachmentFiles, isCloseOut: isCloseOut });
    }

    //Get PSC deficiency details
    public getDeficiencyDetails(pscInspctionId: number): Promise<DeficiencyDetails[]> {
        return this.requestClientService.get<DeficiencyDetails[]>(`${this.pscApi}/GetPscDeficiencyDetails/${pscInspctionId}`, {});
    }
}
